import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { MenuSmallIcon } from '@/icons';
import { cn } from '@/utils';
import { QuizCard } from './QuizCardUI';
type HeaderProps = ComponentPropsWithoutRef<typeof QuizCard.Header>;
export const Header = forwardRef<HTMLDivElement, HeaderProps>((props, ref) => {
  const {
    children,
    className,
    onMouseDown,
    onFocus,
    ...rest
  } = props;
  return <QuizCard.Header ref={ref} className={cn(className, 'py-3xs')} onFocus={e => {
    e.stopPropagation();
    onFocus?.(e);
  }} onMouseDown={e => {
    e.stopPropagation();
    onMouseDown?.(e);
  }} {...rest}>
      <div className="flex w-full flex-col">
        <MenuSmallIcon size="sm" className={cn('rotate-90 self-center')} fill={ICON_COLOR.alternative} />
      </div>
    </QuizCard.Header>;
});
Header.displayName = 'Header';